import { Editor } from "grapesjs";
import { RequiredPluginOptions } from "../../../../../types/types";
import { html } from "../../../../../utils/tw";

export default async (editor: Editor, opts: RequiredPluginOptions) => {
  const { Components } = editor;

  Components.addType("merchant-signup", {
    isComponent: (el) => {
      if (
        el.className &&
        typeof el.className === "string" &&
        el.className.includes("merchant-signup")
      ) {
        return {
          type: "merchant-signup",
        };
      }
      return false;
    },

    model: {
      defaults: {
        tagName: "main",
        classes: ["merchant-signup"],
        components: html`
          <section class="py-6 ">
            <div class="container mx-auto px-4">
              <h3
                class="text-2xl  my-2 text-center font-bold font-roboto tracking-normal text-[var(--primary)]"
              >
                Sign Up
              </h3>
              <form
                id="merchant-signup"
                class="md:px-10 p-6 md:py-6 mx-auto max-w-4xl rounded-lg shadow-[0px_2px_8px_3px_rgba(0,0,0,0.25)] "
              >
                <div class="flex flex-col gap-4">
                  <button
                    type="button"
                    id="resetBtn"
                    class="ml-auto cursor-pointer -mb-[20px] text-[var(--primary)]"
                  >
                    Reset
                  </button>
                  <div class="flex flex-col md:grid md:grid-cols-2  gap-x-6 ">
                    <label class="block">
                      <span class="text-gray-900"
                        >Company Name<span class="text-red-500">*</span></span
                      >
                      <input
                        type="text"
                        name="company_name"
                        id="company_name"
                        class=" border border-gray-200 w-full py-2 px-2 mt-1 rounded-md focus:outline-none"
                      />
                    </label>
                    <label class="block">
                      <span class="text-gray-900"
                        >Owner name<span class="text-red-500">*</span></span
                      >
                      <input
                        type="text"
                        name="full_name"
                        id="full_name"
                        class="border border-gray-200 w-full py-2 px-2 mt-1 rounded-md focus:outline-none"
                      />
                    </label>
                  </div>
                  <div class=" flex flex-col md:grid md:grid-cols-3 gap-x-6 ">
                    <label class="block">
                      <span class="text-gray-900"
                        >Email<span class="text-red-500">*</span></span
                      >
                      <input
                        type="email"
                        name="email"
                        id="email"
                        class="border border-gray-200 w-full py-2 px-2 mt-1 rounded-md focus:outline-none"
                      />
                    </label>
                    <label class="block">
                      <span class="text-gray-900"
                        >Contact no. 1<span class="text-red-500">*</span></span
                      >
                      <input
                        type="tel"
                        name="primary_contact"
                        id="primary_contact"
                        class="border border-gray-200 w-full py-2 px-2 mt-1 rounded-md focus:outline-none"
                      />
                    </label>
                    <label class="block">
                      <span class="text-gray-900">Contact no. 2</span>
                      <input
                        type="tel"
                        name="secondary_contact"
                        id="secondary_contact"
                        class="border border-gray-200 w-full py-2 px-2 mt-1 rounded-md focus:outline-none"
                      />
                    </label>
                  </div>
                  <div class=" flex flex-col md:grid md:grid-cols-2 gap-x-6 ">
                    <label class="block">
                      <span class="text-gray-900"
                        >Address1<span class="text-red-500">*</span></span
                      >
                      <input
                        type="text"
                        name="address"
                        id="address"
                        class="border border-gray-200 w-full py-2 px-2 mt-1 rounded-md focus:outline-none"
                      />
                    </label>
                    <label class="block">
                      <span class="text-gray-900">Address2</span>
                      <input
                        type="text"
                        name="alt_address"
                        id="address_2"
                        class="border border-gray-200 w-full py-2 px-2 mt-1 rounded-md focus:outline-none"
                      />
                    </label>
                  </div>
                  <div class="flex flex-col md:grid md:grid-cols-4  gap-x-6 ">
                    <label class="block">
                      <span class="text-gray-900"
                        >City<span class="text-red-500">*</span></span
                      >
                      <input
                        type="text"
                        name="city"
                        id="city"
                        class="border border-gray-200 w-full py-2 px-2 mt-1 rounded-md focus:outline-none"
                      />
                    </label>
                    <label class="block">
                      <span class="text-gray-900"
                        >State<span class="text-red-500">*</span></span
                      >
                      <input
                        type="text"
                        name="state"
                        id="state"
                        class="border border-gray-200 w-full py-2 px-2 mt-1 rounded-md focus:outline-none"
                      />
                    </label>
                    <label class="block">
                      <span class="text-gray-900">Zip code</span>
                      <input
                        type="text"
                        name="zip_code"
                        id="zip_code"
                        class="border border-gray-200 w-full py-2 px-2 mt-1 rounded-md focus:outline-none"
                      />
                    </label>
                    <label class="block">
                      <span class="text-gray-900"
                        >Country <span class="text-red-500">*</span></span
                      >
                      <input
                        type="text"
                        name="country"
                        id="country"
                        class="border border-gray-200 w-full py-2 px-2 mt-1 rounded-md focus:outline-none"
                      />
                    </label>
                  </div>
                  <div
                    class="flex flex-col  md:grid md:grid-cols-2 gap-x-10 gap-y-6"
                  >
                    <div class="flex flex-col gap-2">
                      <label class="text-gray-900">Company PAN/VAT</label>
                      <div class="flex items-center gap-4">
                        <label
                          class="cursor-pointer px-3 py-1 bg-gray-300  rounded "
                        >
                          Choose File
                          <input
                            type="file"
                            id="vat_pan"
                            name="vat_pan"
                            class="hidden"
                            accept="image/*"
                          />
                        </label>
                        <p id="vat_pan_name" class="text-sm text-gray-700">
                          No file chosen
                        </p>
                      </div>
                    </div>
                    <div class="flex flex-col gap-2 ">
                      <label class="text-gray-900">Citizenship Front</label>
                      <div class="flex items-center gap-4">
                        <label
                          class="cursor-pointer px-3 py-1 bg-gray-300 rounded "
                        >
                          Choose File
                          <input
                            type="file"
                            id="citizenship_front"
                            name="citizenship_front"
                            class="hidden"
                            accept="image/*"
                          />
                        </label>
                        <p
                          id="citizenship_front_name"
                          class="text-sm text-gray-700"
                        >
                          No file chosen
                        </p>
                      </div>
                    </div>
                    <div class="flex flex-col gap-2 ">
                      <label class="text-gray-900">Citizenship Back</label>
                      <div class="flex items-center gap-4">
                        <label
                          class="cursor-pointer px-3 py-1 bg-gray-300 rounded "
                        >
                          Choose File
                          <input
                            type="file"
                            id="citizenship_back"
                            name="citizenship_back"
                            class="hidden"
                            accept="image/*"
                          />
                        </label>
                        <p
                          id="citizenship_back_name"
                          class="text-sm text-gray-700"
                        >
                          No file chosen
                        </p>
                      </div>
                    </div>
                    <div class="flex flex-col gap-2 ">
                      <label class="text-gray-900">Passport</label>
                      <div class="flex items-center gap-4">
                        <label
                          class="cursor-pointer px-3 py-1 bg-gray-300  rounded "
                        >
                          Choose File
                          <input
                            type="file"
                            id="passport"
                            name="passport"
                            class="hidden"
                            accept="image/*"
                          />
                        </label>
                        <p id="passport_name" class="text-sm text-gray-700">
                          No file chosen
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="flex items-center justify-center  mt-6">
                  <button
                    type="submit"
                    id="submitBtn"
                    class="bg-[var(--primary)] cursor-pointer text-white w-52 py-2 rounded relative overflow-hidden ripple-effect button"
                  >
                    Submit Application
                  </button>
                </div>
              </form>
            </div>
          </section>
        `,
        script: function () {
          const checkoutForm = document.querySelector(
            "#merchant-signup"
          ) as HTMLFormElement;

          const fileInputs = document.querySelectorAll('input[type="file"]');

          fileInputs.forEach((input) => {
            input.addEventListener("change", function () {
              const fileName = this.files[0]?.name || "No file chosen";
              const displayId = this.id + "_name";
              const displayElem = document.getElementById(displayId);
              if (displayElem) {
                displayElem.textContent = fileName;
              }
            });
          });

          let validator;
          const initLib = function () {
            //@ts-ignore
            validator = new JustValidate(checkoutForm);

            validator
              .addField("#email", [
                {
                  rule: "required",
                  errorMessage: "Email is required",
                },
                {
                  rule: "email",
                  errorMessage: "Invalid email",
                },
              ])
              .addField("#full_name", [
                {
                  rule: "required",
                  errorMessage: "Full name is required",
                },
              ])
              .addField("#company_name", [
                {
                  rule: "required",
                  errorMessage: "Company Name is required",
                },
              ])
              .addField("#city", [
                {
                  rule: "required",
                  errorMessage: "City is required",
                },
              ])
              .addField("#state", [
                {
                  rule: "required",
                  errorMessage: "State is required",
                },
              ])
              // .addField("#zip_code", [
              //   {
              //     rule: "required",
              //     errorMessage: "Zip code is required",
              //   },
              // ])
              .addField("#country", [
                {
                  rule: "required",
                  errorMessage: "Country is required",
                },
              ])
              .addField("#primary_contact", [
                {
                  rule: "required",
                  errorMessage: "Phone number is required",
                },
                {
                  rule: "customRegexp",
                  value: /^\+\d{7,15}$/,
                  errorMessage:
                    "Enter a valid phone number (e.g. +9779825677664)",
                },
              ])
              .addField("#secondary_contact", [
                {
                  rule: "customRegexp",
                  value: /^\+\d{7,15}$/,
                  errorMessage:
                    "Enter a valid phone number (e.g. +9779825677664)",
                },
              ])
              .addField("#address", [
                {
                  rule: "required",
                  errorMessage: "Address is required",
                },
              ]);
          };
          const initToastLib = function () {};
          const showToast = function (toastMessage, color) {
            //@ts-ignore
            Toastify({
              text: `${toastMessage}`,
              duration: 2000,
              close: false,
              gravity: "top",
              position: "right",
              stopOnFocus: true,
              offset: {
                x: 20,
                y: 60,
              },
              style: {
                background: `${color}`,
              },
            }).showToast();
          };

          const submitBtn = document.getElementById(
            "submitBtn"
          ) as HTMLButtonElement;
          const resetBtn = document.querySelector(
            "#resetBtn"
          ) as HTMLButtonElement;

          resetBtn.addEventListener("click", function (event) {
            event.preventDefault();
            checkoutForm.reset();
          });

          const handleFormSubmit = function () {
            submitBtn.disabled = true;
            submitBtn.classList.add("opacity-50", "cursor-not-allowed");
            const formData = new FormData(checkoutForm);
            fetch(
              `https://apiservice.careinfosolutions.com/apiservice/api/v1/public/merchant-signup/`,
              {
                method: "POST",
                body: formData,
              }
            )
              .then(function (response) {
                return response.json().then((data) => {
                  if (!response.ok) {
                    throw data;
                  }
                  return data;
                });
              })
              .then(function (result) {
                checkoutForm.reset();
                showToast("Submitted successfully ", "green");
              })
              .catch(function (errors) {
                console.error("Error submitting checkout:", errors);
                if (
                  errors &&
                  Object.prototype.toString.call(errors) === "[object Object]"
                ) {
                  const fieldErrors: Record<string, string> = {};
                  const entries = Object.entries(errors);

                  for (let i = 0; i < entries.length; i++) {
                    const key = entries[i][0];
                    const value = entries[i][1];

                    if (Array.isArray(value)) {
                      fieldErrors[`#${key}`] = value.join(", ");
                    } else if (typeof value === "string") {
                      fieldErrors[`#${key}`] = value;
                    }
                  }
                  validator.showErrors(fieldErrors);
                } else if (
                  errors &&
                  Object.prototype.toString.call(errors) ===
                    "[object Object]" &&
                  "message" in errors &&
                  typeof errors.message === "string"
                ) {
                  showToast(errors.message, "red");
                } else {
                  showToast("Unexpected error occurred", "red");
                }
              })
              .finally(() => {
                submitBtn.disabled = false;
                submitBtn.classList.remove("opacity-50", "cursor-not-allowed");
              });
          };

          checkoutForm.addEventListener("submit", function (event) {
            event.preventDefault();
            validator.onSuccess((isValid) => {
              if (!isValid) {
                console.log("Form validation failed.");
                return;
              }
              handleFormSubmit();
            });
          });

          //@ts-ignore
          if (typeof Toastify === "undefined") {
            const script = document.createElement("script");
            script.onload = initToastLib;
            script.src = "https://cdn.jsdelivr.net/npm/toastify-js";
            document.body.appendChild(script);
          } else {
            initToastLib();
          }

          //@ts-ignore
          if (typeof JustValidate === "undefined") {
            const script = document.createElement("script");
            script.onload = initLib;
            script.src =
              "https://unpkg.com/just-validate@latest/dist/just-validate.production.min.js";
            document.body.appendChild(script);
          } else {
            initLib();
          }
        },
      },
    },
  });
};
